import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/eg.json";
import ta from "./locales/ta.json";

const savedLanguage = localStorage.getItem("appLanguage") || "en";
document.documentElement.lang = savedLanguage;
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ta: { translation: ta }
    },
    lng: savedLanguage,
    fallbackLng: "ta",
    interpolation: {
      escapeValue: false
    }
  });
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});
export default i18n;